module.exports = __webpack_public_path__ + "static/media/nat-1-large.7fdf2a88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/nat-1-large.jpg
// module id = 845
// module chunks = 0